import React, { Component } from 'react'
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push, replace } from "connected-react-router";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Fingerprint from "@material-ui/icons/Fingerprint";
import PhoneIphone from "@material-ui/icons/PhoneIphone";
import Sms from "@material-ui/icons/Sms";
import Mail from "@material-ui/icons/Mail";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import defaultUserImage from 'assets/img/no_profile.png';

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";
import { roseColor } from "assets/jss/material-dashboard-pro-react.jsx";
import { store } from "../../redux/store";
import { LOGIN_SUCCESS, SET_NOTIFICATIONS } from "../../redux/types";
import Api from "../../api/Api.js";
import Loading from '../../components/Loading/Loading.jsx';
import { Tooltip } from '@material-ui/core';
import AuthEndpoints from '../../api/AuthEndpoints';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

class OTP extends Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        var availableOtp = [];

        if (this.props.otp_mfa_enabled)
            availableOtp.push("mfa");

        if (this.props.otp_email_enabled)
            availableOtp.push("email");

        if (this.props.otp_sms_enabled)
            availableOtp.push("sms");

        this.state = {
            cardAnimaton: "cardHidden",
            otp: '',
            otpInvalid: false,
            otpType: availableOtp.length === 1 ? 'mfa' : '',
            loading: availableOtp.length === 1 && availableOtp[0] !== "mfa"
        };

        if (availableOtp.length === 1) {
            switch (availableOtp[0]) {
                case "mfa":
                    this.useMFA();
                    break;

                case "sms":
                    this.useSMS();
                    break;

                case "email":
                    this.useEmail();
                    break;
            }
        }
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );

        if (!this.props.otp_mfa_enabled && !this.props.otp_email_enabled && !this.props.otp_sms_enabled || !this.props.auth.username || !this.props.auth.password) {
            store.dispatch(push('/login'))
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }

    async submitLogin() {
        if (this.otpIsInvalid()) {
            this.setState({ otpInvalid: true });
            return;
        }
        this.setState({ loading: true }, async () => {

            var recaptchaTimeout;

            const recaptcha_token = await Promise.race(
                [
                    this.props.googleReCaptchaProps.executeRecaptcha('otp'),
                    new Promise((resolve, reject) => {
                        recaptchaTimeout = setTimeout(() => {
                            resolve(null);
                        }, 1000);
                    })
                ]
            );

            if (recaptchaTimeout)
                clearTimeout(recaptchaTimeout);

            Api.login(this.props.auth.username, this.props.auth.password, { [this.state.otpType]: this.state.otp }, { recaptcha_token })
                .then((response) => {
                    let data;

                    if (!response.data) {
                        console.error("No Usable Data Received from Login Attempt");
                        this.setState({ password: '', passwordInvalid: true, usernameInvalid: false, loading: false });
                        return;
                    } else {
                        data = response.data;
                    }

                    Api.loggedIn(data.token, data.user.role.role1, data)
                    store.dispatch({ type: LOGIN_SUCCESS, user: data.user });
                    store.dispatch({ type: SET_NOTIFICATIONS, payload: data.notifications });
                    store.dispatch(replace('/dashboard'));
                })
                .catch((e) => this.setState({ otp: '', otpInvalid: true, loading: false }, () => console.error(e)))
        });
    }

    useMFA = () => this.setState({ otpType: 'mfa' }) //No Initializing Callbacks Required

    useEmail() {
        this.setState({ loading: true }, () => {
            Api.post(AuthEndpoints.sendEmailOtp, this.props.auth, 1, false)
                .then(() => {
                    this.setState({ otpType: 'email', loading: false })
                })
                .catch((e) => {
                    this.setState({ loading: false });
                    console.error(e);
                })
        })
    }

    useSMS() {
        this.setState({ loading: true }, () => {
            Api.post(AuthEndpoints.sendSMSOtp, this.props.auth, 1, false)
                .then(() => {
                    this.setState({ otpType: 'sms', loading: false })
                })
                .catch((e) => {
                    this.setState({ loading: false })
                    console.error(e);
                })
        })
    }

    getTitle() {
        switch (this.state.otpType) {
            case "mfa":
                return "Enter Auth Code:";
            case "email":
            case "sms":
                return "Enter OTP:";
            default:
                return "Pick Authentication Method";
        }
    }

    otpIsInvalid() {
        return (
            (this.state.otp.length !== 6 && this.state.otpType === "sms")
            ||
            (this.state.otp.length !== 10 && this.state.otpType === "email")
            ||
            (this.state.otp.length !== 6 && this.state.otpType === "mfa")
        ) || !(/^[0-9]{0,10}$/.test(this.state.otp));
    }

    renderAuthPicker() {

        const { classes } = this.props;

        return (
            <div style={{ display: 'flex', width: "100%", paddingTop: 10, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                {
                    this.props.otp_mfa_enabled ?
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            <Tooltip
                                id="tooltip-top-start"
                                title={"2FA a.k.a. Authy / Google Authenticator"}
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                            >
                                <Button onClick={() => this.useMFA()} justIcon round color="rose" disabled={this.state.loading || this.state.otpType === "mfa"}><PhoneIphone /></Button>
                            </Tooltip>
                        </div>
                        : null
                }
                {
                    this.props.otp_email_enabled ?
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            <Tooltip
                                id="tooltip-top-start"
                                title="Email Authentication"
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                            >
                                <Button onClick={() => this.useEmail()} justIcon round color="rose" disabled={this.state.loading || this.state.otpType === "email"}><Mail /></Button>
                            </Tooltip>
                        </div>
                        : null
                }
                {
                    this.props.otp_sms_enabled ?
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            <Tooltip
                                id="tooltip-top-start"
                                title="SMS Authentication"
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                            >
                                <Button onClick={() => this.useSMS()} justIcon round color="rose" disabled={this.state.loading || this.state.otpType === "sms"}><Sms /></Button>
                            </Tooltip>
                        </div>
                        : null
                }
            </div>
        );
    }

    renderAuthInput() {
        return (
            <CustomInput
                labelText={(this.state.otpInvalid ? "Invalid Pin" : "Pin")}
                id="otp"
                success={!this.otpIsInvalid()}
                error={this.state.otpInvalid}
                formControlProps={{
                    fullWidth: true
                }}
                labelProps={{
                    style: {
                        fontSize: 24,
                        textAlign: 'center'
                    }
                }}
                inputProps={{
                    onChange: (event) => {
                        if (/^[0-9]{0,10}$/.test(event.target.value))
                            this.setState({ otp: event.target.value, otpInvalid: false });
                    },
                    value: this.state.otp,
                    onKeyPress: (e) => {
                        if (e.key === 'Enter') {
                            this.submitLogin();
                        }
                    },
                    inputProps: {
                        style: {
                            fontSize: 24,
                            letterSpacing: 4,
                            textAlign: 'center'
                        }
                    }
                }}
            />
        );
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Card
                        profile
                        className={
                            classes.customCardClass + " " + classes[this.state.cardAnimaton]
                        }
                        {
                        ...(
                            this.state.otpType ?
                                {}
                                :
                                { style: { paddingTop: 10 } }
                        )
                        }
                    >
                        {
                            this.state.otpType ?
                                this.renderAuthPicker()
                                :
                                <CardAvatar profile className={classes.cardAvatar} style={{ backgroundColor: roseColor, padding: 20, ...(this.state.loading ? { paddingBottom: 24, paddingTop: 24 } : { paddingBottom: 20, paddingTop: 20 }) }}>
                                    {
                                        this.state.loading ?
                                            <Loading color="white" />
                                            :
                                            <Fingerprint style={{ fontSize: 45 }} />
                                    }
                                </CardAvatar>
                        }
                        <CardBody profile>
                            <h4 className={classes.cardTitle}>
                                {
                                    this.state.loading ?
                                        (
                                            this.state.otpType ?
                                                "Please Wait..."
                                                :
                                                <span>Requesting...<br />Please Wait...</span>
                                        )
                                        :
                                        this.getTitle()
                                }
                            </h4>

                            {
                                this.state.otpType ?
                                    this.renderAuthInput()
                                    :
                                    this.renderAuthPicker()
                            }
                        </CardBody>

                        {
                            this.state.otpType ?
                                <CardFooter className={classes.justifyContentCenter}>
                                    {
                                        this.state.loading ?
                                            <div style={{ paddingBottom: 10 }}>
                                                <Loading />
                                            </div>
                                            :
                                            <Button color="rose" round onClick={() => this.submitLogin()}
                                                disabled={this.otpIsInvalid()}
                                            >
                                                <Icon className={classes.inputAdornmentIcon}>
                                                    lock_open_outline
                                                </Icon>
                                                Continue
                                    </Button>
                                    }
                                </CardFooter>
                                :
                                null
                        }
                    </Card>
                </form>
            </div>
        );
    }
}

OTP.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({ ...state.user });

export default withStyles(lockScreenPageStyle)(withGoogleReCaptcha(connect(mapStateToProps)(OTP)));